import { useCallback, useContext } from "react";
import { resetCheckoutError } from "./actions";
import { CheckoutContext, CheckoutDispatchContext } from "./context";

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error(
      "Tried to access CheckoutContext outside of a CheckoutProvider"
    );
  }
  return context;
};

export const useCheckoutState = () => {
  return useCheckoutContext().state;
};

export const useCheckoutError = () => useCheckoutState().error;

export const useCheckoutDispatch = () => {
  const dispatch = useContext(CheckoutDispatchContext);
  if (!dispatch) {
    throw new Error(
      "useCheckoutDispatch must be used within a CheckoutProvider"
    );
  }

  return dispatch;
};

export const useToken = () => useCheckoutContext().token;

export const useCheckoutConfig = () => {
  const { token, centraUrl } = useCheckoutContext();

  return {
    token,
    centraUrl,
  };
};

export const useResetCheckoutError = () => {
  const dispatch = useCheckoutDispatch();

  return useCallback(() => {
    dispatch(resetCheckoutError());
  }, []);
};
